import { CHART_CONSTANTS } from '../constants';
import { AccessibilityScoreData, ChartData, ChartDataPoint, ChartSeries } from '../types';

import { formatDateForDisplay } from './dateFormatHelpers';

/**
 * Creates categories array for X-axis labels
 */
export const createCategoriesWithSelectiveLabels = (data: AccessibilityScoreData[]): string[] => {
	return data.map((item) => formatDateForDisplay(item.date));
};

/**
 * Creates chart data points from accessibility score data
 */
export const createChartDataPoints = (data: AccessibilityScoreData[]): ChartDataPoint[] => {
	return data.map((item, index) => {
		const dateStr = item.date;
		return {
			x: index,
			y: item.score,
			name: formatDateForDisplay(item.date),
			date: dateStr,
			score: item.score
		};
	});
};

/**
 * Creates the chart series configuration for accessibility scores
 */
const createAccessibilityScoreSeries = (data: AccessibilityScoreData[]): ChartSeries[] => {
	return [
		{
			type: CHART_CONSTANTS.SERIES.TYPE,
			name: CHART_CONSTANTS.SERIES.NAME,
			data: createChartDataPoints(data),
			color: CHART_CONSTANTS.COLORS.PRIMARY_LINE,
			lineWidth: CHART_CONSTANTS.LINE.WIDTH,
			marker: {
				enabled: true,
				fillColor: CHART_CONSTANTS.COLORS.PRIMARY_LINE,
				lineColor: CHART_CONSTANTS.COLORS.PRIMARY_LINE,
				lineWidth: CHART_CONSTANTS.LINE.WIDTH,
				radius: CHART_CONSTANTS.LINE.MARKER_RADIUS
			}
		}
	];
};

/**
 * Prepares data for accessibility chart rendering
 */
export const prepareDataForAccessibilityChart = (data: AccessibilityScoreData[]): ChartData => {
	const categories = createCategoriesWithSelectiveLabels(data);
	const series = createAccessibilityScoreSeries(data);

	return {
		categories,
		series
	};
};
